var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { convertToFormData } from './Helpers/Helpers';
import getClientFingerprint from '@common/utils/ClientFingerprint';
import { isDev } from '@common/utils/Environment';
import { HttpClient } from '@common/utils/HttpClients/HttpClient';
/**
 * Общий клиент
 */
var httpClient = new HttpClient({});
// Интерцептор проверяет ответы на наличие 401, чтобы попробовать обновить рефреш токен
httpClient.interceptors.response.use(function (response) { return response; }, rejectHandler);
/**
 * Клиент для апи школы
 */
var httpClientApiSchool = new HttpClient({
    baseURL: "/api/school",
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
});
// Интерцептор проверяет ответы на наличие 401, чтобы попробовать обновить рефреш токен
httpClientApiSchool.interceptors.response.use(function (response) { return response; }, rejectHandler);
/**
 * Клиент для апи ученика
 */
var httpClientApiStudent = new HttpClient({
    baseURL: "/api/student",
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
});
// Интерцептор проверяет ответы на наличие 401, чтобы попробовать обновить рефреш токен
httpClientApiStudent.interceptors.response.use(function (response) { return response; }, rejectHandler);
/**
 * Клиент для апи ученика
 */
var httpClientApiVerify = new HttpClient({
    baseURL: "/api/verify",
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
});
// Интерцептор проверяет ответы на наличие 401, чтобы попробовать обновить рефреш токен
httpClientApiVerify.interceptors.response.use(function (response) { return response; }, rejectHandler);
/**
 * Обработка ошибки авторизации
 *
 * @param {any} error Ошибка
 * @returns {Promise<any>}
 */
function rejectHandler(error) {
    var _this = this;
    var _a;
    // Выбрасываем ошибку, если проблема не в авторизации
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== 401) {
        return Promise.reject(error);
    }
    // Если ошибка в авторизации - разбираемся с токенами
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var fingerprint;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getClientFingerprint()];
                case 1:
                    fingerprint = _a.sent();
                    // Пытаемся обновить токен
                    axios.post('/api/user/refresh', convertToFormData({ fingerprint: fingerprint, }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded', }, }).then(function (_response) {
                        // Токены обновились - повторяем запрос и возвращаем его результат
                        axios(error.response.config)
                            .then(function (res) {
                            resolve(res);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }).catch(function (err) {
                        // Здесь нужно рефрешить страницу, т.к. юзер уже точно не авторизован
                        console.error(err);
                        document.location.reload();
                        reject(err);
                    });
                    return [2 /*return*/];
            }
        });
    }); });
}
export { httpClient, httpClientApiSchool, httpClientApiStudent, httpClientApiVerify, };
// для запросов в браузере
if (isDev()) {
    window.__httpClients = {
        default: httpClient,
        school: httpClientApiSchool,
        student: httpClientApiStudent,
        verify: httpClientApiVerify,
    };
}
